var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.team !== null)?_c('v-row',[_vm._l((_vm.team),function(user){return [_c('v-col',{key:user.uid,attrs:{"cols":"12","lg":"4","md":"4","sm":"6","xl":"4"}},[_c('TeamMemberCard',{attrs:{"member":user}})],1)]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }